<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormTimbradoRutaBase" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Version">Versión</label>
							<input type="text" v-model="objTimbradoRutaBase.Version" class="form-control" id="Version" placeholder="Ingresar Version" />
							<CValidation v-if="this.errorvalidacion.Version" :Mensaje="'*'+errorvalidacion.Version[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Estatus">Estatus</label>
							<select v-model="objTimbradoRutaBase.Estatus" class="form-control form-select" id="Estatus">
								<option value="InActivo">InActivo</option>
								<option value="Activo">Activo</option>
							</select>
							<CValidation v-if="this.errorvalidacion.Estatus" :Mensaje="'*'+errorvalidacion.Estatus[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Url">Url</label>
							<input type="text" v-model="objTimbradoRutaBase.Url" class="form-control" id="Url" placeholder="Ingresar Url" />
							<CValidation v-if="this.errorvalidacion.Url" :Mensaje="'*'+errorvalidacion.Url[0]"/>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="UrlCancelacion">Url Cancelación</label>
							<input type="text" v-model="objTimbradoRutaBase.UrlCancelacion" class="form-control" id="UrlCancelacion" placeholder="Ingresar UrlCancelacion" />
							<CValidation v-if="this.errorvalidacion.UrlCancelacion" :Mensaje="'*'+errorvalidacion.UrlCancelacion[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="TipoRuta">Tipo de Ruta</label>
							<select v-model="objTimbradoRutaBase.TipoRuta" class="form-control form-select" id="TipoRuta">
								<option value="Pruebas">Pruebas</option>
								<option value="Produccion">Producción</option>
							</select>
							<CValidation v-if="this.errorvalidacion.TipoRuta" :Mensaje="'*'+errorvalidacion.TipoRuta[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Usuario">Usuario</label>
							<input type="text" v-model="objTimbradoRutaBase.Usuario" class="form-control" id="Usuario" placeholder="Ingresar Usuario" />
							<CValidation v-if="this.errorvalidacion.Usuario" :Mensaje="'*'+errorvalidacion.Usuario[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Acceso">Acceso</label>
							<input type="text" v-model="objTimbradoRutaBase.Acceso" class="form-control" id="Acceso" placeholder="Ingresar Acceso" />
							<CValidation v-if="this.errorvalidacion.Acceso" :Mensaje="'*'+errorvalidacion.Acceso[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormTimbradoRutaBase',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objTimbradoRutaBase: {
				IdRutaBase: 0,
				Version: '',
				Url: '',
				UrlCancelacion: '',
				TipoRuta: 'Pruebas',
				Usuario: '',
				Acceso: '',
				Estatus: 'InActivo',
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objTimbradoRutaBase.IdRutaBase == 0) {
				await this.$http.post(
					'timbradoRutasBase',this.objTimbradoRutaBase
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'timbradoRutasBase/'+this.objTimbradoRutaBase.IdRutaBase,
					this.objTimbradoRutaBase
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "timbradoRutasBase/"+this.objTimbradoRutaBase.IdRutaBase
            ).then((res) => {
                this.objTimbradoRutaBase = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objTimbradoRutaBase.Fecha.replace(/-/g,'\/');
                this.objTimbradoRutaBase.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objTimbradoRutaBase = {
				IdRutaBase: 0,
				Version: '',
				Url: '',
				UrlCancelacion: '',
				TipoRuta: 'Pruebas',
				Usuario: '',
				Acceso: '',
				Estatus: 'InActivo',
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objTimbradoRutaBase.IdRutaBase = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
